<template>
  <div :class="'col-md-' + col" class="group-autocomplete" :style="{'margin-bottom': marginBottom}">
    <input :disabled="haveSelected"
           @click="openSearch()"
           type="text"
           placeholder="Digite o nome da empresa"
           v-model="search"
           @blur="toggle = false"
           @focus="toggle = true"
           @keydown.enter.prevent>
    <ion-icon v-if="!haveSelected" name="search-outline" class="ion-autocomplete"></ion-icon>
    <span v-else @click="clearInput()" class="ion-autocomplete-selected" :id="'element-close'">
      <ion-icon name="close-outline"></ion-icon>
    </span>
    <div class="results" v-if="toggle">
      <div @click="selectResult(value)" @mousedown.prevent class="result" v-for="(value, index) in newValue"
           :key="index">
        <span>
          {{ value.name }}
        </span>
      </div>
    </div>
    <span class="textError" v-if="inputError">Preencha o campo *</span>
  </div>
</template>

<script>

export default {
  name: "inputAutocomplete",
  props: {
    value: '',
    type: '',
    col: {
      default: ''
    },
    marginBottom: {
      default: ''
    },
    valueReturnObj: {
      default: false
    },
    clearInputOnSelect: {
      default: false
    },
    inputError: {
      default: false
    },
    selectedCompanyId: {
      default: '',
    }
  },
  data() {
    return {
      haveSelected: false,
      search: '',
      selectedId: '',
      toggle: false,
      newValue: [],
      returnedValue: '',
    }
  },
  watch: {
    returnedValue(newValue, oldValue) {
      this.$emit('valueAutocomplete', newValue)

      if (this.clearInputOnSelect) {
        setTimeout(() => {
          const element = document.getElementById('element-close');
          const eventClick = new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window
          });
          element.dispatchEvent(eventClick);
        }, 1)
      }
    },

    setValue() {
      this.newValue = this.$props.value
    },
    value: function (val) {
      if (this.selectedCompanyId) {
        const selectCompany = this.$props.value.find(company => company.id === this.selectedCompanyId);
        if (selectCompany) {
          this.haveSelected = true;
          this.search = selectCompany.name;
        }
      }

      this.newValue = val;
    },
    search(val) {
      this.newValue = [];
      this.$props.value.forEach(element => {
        if (element.name.toLowerCase().includes(val.toLowerCase()) || element.id === val && val !== "") {
          this.newValue.push(element);
        }
      });
    },
  },
  methods: {
    selectResult(value) {
      this.search = value.name;
      this.selectedId = value.id;
      this.toggle = false;

      if (this.valueReturnObj) {
        this.returnedValue = {
          name: value.name,
          id: value.id
        }
      } else {
        this.$route.params.selectedIdTicket = this.selectedId
      }


      if (this.selectedId !== '') {
        this.haveSelected = true
      } else {
        this.haveSelected = false
      }
    },
    openSearch() {
      if (this.toggle) {
        if (this.search === '' && this.newValue.length === 0) {
          this.newValue = this.$props.value;
        }
      }

    },
    clearInput() {
      this.search = '';
      this.selectedId = '';
      this.$route.params.selectedIdTicket = ''
      this.haveSelected = false
    },
  },
  beforeMount() {
    if (this.type === 1) {
      this.newValue = this.$props.value
    }
  }
}
</script>

<style lang="scss" scoped>

.group-autocomplete {
  position: relative;

  .ion-autocomplete {
    position: absolute;
    right: 10px;
    top: 10px;
    font-size: 16px;
    color: var(--dark-gray);
  }

  .ion-autocomplete-selected {
    position: absolute;
    right: 10px;
    top: 10px;
    font-size: 16px !important;
    color: var(--light-red) !important;
    cursor: pointer !important;
  }
}

input {
  width: 100%;
  background: #EEF2F7;
  border-radius: 4px !important;
  padding: 6px 12px;
  border: 1px solid #EEF2F7;
  transition: .2s;
  font-size: 16px;
  font-weight: 400;
  color: var(--dark-gray);

  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  &::placeholder {
    font-size: 16px;
    font-weight: 400;
    color: var(--dark-gray);
  }

  &:hover {
    transition: .2s;
    border: 1px solid #CACACA;
  }

  &:focus-visible {
    outline: none;
    transition: .2s;
    border: 1px solid #CACACA;

    &::placeholder {
      transition: .1s;
      color: #EEF2F7;
    }
  }
}

.results {
  max-height: 300px;
  overflow: auto;
  z-index: 1;
  border-bottom-left-radius: 8px !important;
  border-bottom-right-radius: 8px !important;
  position: absolute;
  width: 100%;
  background: #EEF2F7;
  box-shadow: 0 0 0 rgba(0, 0, 0, 0), 0 2px 6px rgba(0, 0, 0, 0.23);

  .result {
    cursor: pointer;
    padding: 5px 10px;

    &:hover {
      background: #EFEFEF;
    }
  }
}

.results::-webkit-scrollbar {
  width: 10px;
  position: absolute;
}

.results::-webkit-scrollbar-track {
  background-color: #EEF2F7;
  height: 2px;
  border-radius: 4px;
}

.results::-webkit-scrollbar-thumb {
  background: #3A424E;
  border-radius: 4px;
}

.results::-webkit-scrollbar-thumb:hover {
  background: lighten(#3A424E, 5%);
  transition: 0.5s;
}

.textError {
  position: absolute;
  left: 2px;
  bottom: -15px;
  font-size: 11px;
  color: #D9534F;
}

</style>



// WEBPACK FOOTER //
// src/vue/pages/components/inputs/inputAutocomplete.vue